var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('LoadingPage'):_c('div',[_c('TrackingTemplate',{attrs:{"order":_vm.order,"status-step":_vm.statusStep,"add-info-color":_vm.addInfoColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }